import React, { Component } from 'react';
import Dropdown from 'react-dropdown'
import {ALL, COMPUTER_KEYBOARD, CUSTOM} from 'constants/midi-input-types.js';
import '../../Track.scss';
import { connect } from "react-redux";
import {setContextualHelp} from "actions/index.js";
import {TRACK_MIDI_DROPDOWN} from 'constants/contextual-help.js';

class TrackMidiInputDropdown extends Component {
    constructor(props) {
        super(props);
    }

    getOptions() {
        let engine = this.props.midiEngine;
        let options = [
            {label: 'All', value: {type: ALL}},
            {label: 'Computer Keyboard', value: {type: COMPUTER_KEYBOARD}},
        ];
        let otherOptions = engine.getInputs()
            .map(i => ({label: i.name, value: {type: CUSTOM, input: i}}));

        return options.concat(otherOptions);
    }

    getSelectedOption() {
        let inputs = this.props.midiInputs;
        return this.getOptions()
            .filter(option => {
                if (option.value.type === inputs.type) {
                    if (inputs.type === CUSTOM) {
                        return inputs.accepts(false, option.value.input.name);
                    } else {
                        return true;
                    }
                }

                return false;
            })[0];
    }

    onSelect(o) {
        if (o.value.type === CUSTOM) {
            this.props.midiInputs.addMidiInput(o.value.input);
        } else {
            this.props.midiInputs.setType(o.value.type);
        }
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation();
        this.props.setContextualHelp(contextualHelp);
    }

    render() {
        return (
            <div
              onMouseOver={(e) => this.setContextualHelp(e, TRACK_MIDI_DROPDOWN)}
              onMouseLeave={() => this.props.setContextualHelp(undefined)}
              className="midi-input-dropdown-container">
              <Dropdown
                className='midi-input-dropdown'
                controlClassName='midi-input-control-dropdown'
                arrowClassName='audio-input-arrow-dropdown'
                options={this.getOptions()}
                onChange={(o) => this.onSelect(o)}
                value={this.getSelectedOption()}
                placeholder="Input" />
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(TrackMidiInputDropdown);
